import { Icon } from '@types';

export const Logout = ({ customStyles, handleClick, disabled, error }: Icon) => {
	return (
		<svg
			className={customStyles}
			onClick={handleClick}
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M21.8047 12.0703L16.1797 6.44531C15.9453 6.21094 15.5156 6.21094 15.2812 6.44531C15.0469 6.67969 15.0469 7.10938 15.2812 7.34375L19.8516 11.875H8.875C8.52344 11.875 8.25 12.1875 8.25 12.5C8.25 12.8516 8.52344 13.125 8.875 13.125H19.8516L15.2812 17.6953C15.0469 17.9297 15.0469 18.3594 15.2812 18.5938C15.5156 18.8281 15.9453 18.8281 16.1797 18.5938L21.8047 12.9688C21.9219 12.8516 22 12.6953 22 12.5C22 12.3438 21.9219 12.1875 21.8047 12.0703ZM8.875 20H5.125C4.07031 20 3.25 19.1797 3.25 18.125V6.875C3.25 5.85938 4.07031 5 5.125 5H8.875C9.1875 5 9.5 4.72656 9.5 4.375C9.5 4.0625 9.1875 3.75 8.875 3.75H5.125C3.36719 3.75 2 5.15625 2 6.875V18.125C2 19.8828 3.36719 21.25 5.125 21.25H8.875C9.1875 21.25 9.5 20.9766 9.5 20.625C9.5 20.3125 9.1875 20 8.875 20Z"
				fill={disabled ? '#636363' : error ? '#E22339' : '#008635'}
			/>
		</svg>
	);
};
